












import findIndex from 'lodash/findIndex'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { RawTag as Tags } from '@/models/api/tags'

import MailMagazineCheckItem from './MailMagazineCheckItem.vue'

@Component({
  components: {
    MailMagazineCheckItem,
  },
})
export default class MailMagazineCheckList extends Vue {
  @Prop({ required: true })
  magazines: Tags[]

  @Prop({ default: null })
  change: ((checkedIndex: number, checkedItem: Tags, changedArray: Tags[]) => void) | null

  get orderedMagazines(): Tags[] {
    return this.magazines.sort((a, b) => {
      if (a.display_level === b.display_level) {
        return 0
      }

      return a.display_level < b.display_level ? -1 : 1
    })
  }

  handleChange(checked: Tags) {
    const checkedIndex = findIndex(this.magazines, magazine => magazine.id === checked.id)
    const after = (() => {
      const copy = [...this.magazines]

      copy[checkedIndex] = checked

      return copy
    })()

    if (this.change === null) {
      return
    }
    this.change(checkedIndex, checked, after)
  }
}
